import { Injectable } from '@angular/core';
import { FireService } from './fire.service';
import { Functions, getFunctions, httpsCallable } from 'firebase/functions';
import { AnalyticsService } from './analytics.service';
import { QueryResult } from './query-result';

@Injectable({
    providedIn: 'root',
})
export class FuncService {
    private readonly functions!: Functions;

    constructor(fire: FireService, private analytics: AnalyticsService) {
        this.functions = getFunctions(fire.app, 'europe-west1');
        // if (!environment.production) {
        //     connectFunctionsEmulator(this.functions, "localhost", 5001);
        // }
    }

    public async runQuery(query: string): Promise<QueryResult> {
        const result = await httpsCallable<string, QueryResult>(
            this.functions,
            'runQuery'
        )(query);
        console.log({
            msg: 'FuncService.Query results',
            query: query,
            data: result,
        });
        return result.data;
    }

    /**
     * Gets access token to execute query via BigQuery API.
     * @returns
     */
    public async getQueryToken(): Promise<string> {
        const result = await httpsCallable<undefined, string>(
            this.functions,
            'getQueryToken'
        )();
        return result.data;
    }

    public async orchestrateBiFromSegments(): Promise<void> {
        await httpsCallable<undefined, string>(
            this.functions,
            'orchestrateBiFromSegments'
        )();
    }

    // public async setAuthorizedClaims<Type>(uid: string): Promise<void> {
    //     console.log({msg: 'FuncService.setAuthorizeClaims', uid});
    //     const callable = httpsCallable<string, void>(this.functions, 'setAuthorizedClaims');

    //     return callable(uid).then(
    //         result => {
    //             console.log({msg: "FuncService.setAuthorizeClaims results", uid, result})
    //             // return result.data;
    //         }
    //     );
    // };

    // public async getCustomClaims<Type>(uid: string): Promise<void> {
    //     console.log({msg: 'FuncService.getCustomClaims', uid});
    //     const callable = httpsCallable<string, Type[]>(this.functions, 'getCustomClaims');

    //     return callable(uid).then(
    //         result => {
    //             console.log({msg: "FuncService.getCustomClaims results", uid, result})
    //             // return result.data;
    //         }
    //     );
    // };
}
